import React from 'react';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';
import { toSvgColor } from 'apps/sigma2-ui/src/components/svg/types';

export const Sigma2LogoNoFillGroup: React.FC<SvgProps> = (props) => {
  const fillColor = toSvgColor('currentColor', props);

  return (
    <g fill="none" {...(props.group ?? {})}>
      <path
        d="M79.79 35.926V46.08H60.943c2.266 4.094 4.968 7.859 6.566 12.04 7.022 18.39-3.39 38.774-22.46 44.408a34.167 34.167 0 0 1-26.94-3.072A34.123 34.123 0 0 1 1.912 77.723a34.088 34.088 0 0 1 4.77-26.676 34.121 34.121 0 0 1 22.727-14.782 29.55 29.55 0 0 1 4.794-.445h43.66c.571 0 1.104.048 1.927.106Zm-44.493 10.26a23.697 23.697 0 0 0-16.738 6.965 23.668 23.668 0 0 0 .061 33.481 23.697 23.697 0 0 0 38.624-7.751A23.663 23.663 0 0 0 52.06 53.09a23.691 23.691 0 0 0-16.764-6.904ZM119.857 35.694v10.202H83.858c0-3.194-.077-6.301.068-9.389 0-.61.843-1.297 1.443-1.732 4.843-3.524 9.86-6.93 14.692-10.521a32.455 32.455 0 0 0 5.492-5.053 4.889 4.889 0 0 0 .455-6.243 4.99 4.99 0 0 0-6.102-1.5c-2.605 1.277-4.842 3.213-7.603 5.062l-7.931-6.553c5.51-9.524 19.902-12.96 29.006-7.056a14.312 14.312 0 0 1 2.906 21.14 51.153 51.153 0 0 1-7.409 6.475c-2.121 1.674-4.426 3.126-6.577 5.139l17.559.03Z"
        fill={fillColor}
      />
    </g>
  );
};

export const Sigma2LogoNoFillSvg: React.FC<SvgProps> = (props) => {
  return (
    <svg
      width="120"
      height="104"
      viewBox="0 0 120 104"
      xmlns="http://www.w3.org/2000/svg"
      {...(props.svg ?? {})}
    >
      <Sigma2LogoNoFillGroup {...props} />
    </svg>
  );
};
